import { ethereum } from '@0xtorch/core'
import { scroll } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createScrollChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}) => {
  return createScrollChainCustom({
    client: createClient({
      chain: scroll,
      httpRpcs: scrollHttpRpcs,
    }),
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'Scroll Blockscout',
      baseUrl: 'https://scroll.blockscout.com',
      apiBaseUrl: 'https://scroll.blockscout.com/api',
      proxyUrl,
    }),
  })
}

type CreateScrollChainParameters = {
  client: Client
  explorer: Explorer
}

export const createScrollChainCustom = ({
  client,
  explorer,
}: CreateScrollChainParameters): Chain => ({
  id: 534_352,
  network: 'scroll',
  name: 'Scroll',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x5300000000000000000000000000000000000004',
  ]),
  explorer,
  client,
  blockTime: 3000,
  coingeckoId: 'scroll',
  defillamaId: 'scroll',
})

export const scrollHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.scroll.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://rpc-scroll.icecreamswap.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://scroll-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://scroll.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1024n,
  // },
  {
    url: 'https://1rpc.io/scroll',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://scroll.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://scroll-mainnet.rpc.grove.city/v1/a7a7c8e2',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://scroll.api.onfinality.io/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
]

export const scrollWebsocketRpcUrls: readonly string[] = []
